import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useFetch, usePromise } from '@rad/hooks';
import { Tabs } from '@rad/components/ui/tabs';
import Redirect from '@rad/components/utility/redirect';
import { getParcel } from '../../common/network/parcels';
import { landingRoutes, propertyRoutes, defaultPropertyBack } from '../../common/routes';
import useBackLink from '../../hooks/useBackLink';
import E404 from '../system/no-layout-404';
import SidebarPanel from './components/property/sidebar-panel';
import UnclaimedView from './components/property/unclaimed-view';
import Hero from './components/property/hero';
import Layout from './components/property/layout';
const Skeleton = (props) => _jsx(Layout, { hero: _jsx(Hero, { slides: [], fallback: null, address: "", back: props.back }), sidebar: _jsx(_Fragment, { children: _jsx(SidebarPanel, { icon: "bi bi-info-circle", title: "Quick Facts", children: _jsx("div", { className: "d-flex flex-column gap-2", children: [0, 1].map((i) => _jsx("div", { className: "skeleton-block rounded border", style: { 'height': 38 } }, i)) }) }) }), main: _jsx(_Fragment, { children: _jsxs(Tabs, { hashKey: "tab", disabled: true, children: [_jsx(Tabs.Tab, { default: true, id: "timeline", label: "Timeline" }), _jsx(Tabs.Tab, { id: "people", label: "People" }), _jsx(Tabs.Tab, { id: "photos", label: "Photos" }), _jsx(Tabs.Tab, { id: "contributors", label: "Contributors" })] }) }) });
// The property page for a parcel id. An address someone has already contributed a public view of
// hands off to its property page, so a stale map marker still lands on the real record.
const UnclaimedProperty = (props) => {
    const [detailP] = useFetch(getParcel(props.id));
    const detail = usePromise(detailP);
    const resolveBack = useBackLink();
    const back = resolveBack(defaultPropertyBack());
    return detail === undefined
        ? _jsx(Skeleton, { back: back })
        : detail === null
            ? _jsx(E404, { urlHome: landingRoutes.root.getURL() })
            : detail.propertyId
                ? _jsx(Redirect, { target: propertyRoutes.property.getURL({ 'id': detail.propertyId }) })
                : _jsx(UnclaimedView, { address: detail.parcel.address, point: detail.parcel.point, kind: detail.parcel.kind, back: back, target: { 'kind': 'parcel', 'id': detail.parcel.id } });
};
export default UnclaimedProperty;
